import React from 'react';
import { Tag } from 'antd';
import { transactionTypeMeta } from './transactionTypes';
import './TransactionType.css';

export type TransactionTypeVariant = 'soft' | 'solid' | 'plain';

interface TransactionTypeTagProps {
  /** Mã giao dịch từ backend hoặc nhãn tiếng Việt. */
  value?: string | null;
  /** soft: tag nhạt (mặc định) | solid: tag đậm | plain: chỉ icon + chữ, không nền. */
  variant?: TransactionTypeVariant;
  className?: string;
}

/** Hiển thị "Loại giao dịch" kèm icon và màu thống nhất toàn hệ thống. */
const TransactionTypeTag: React.FC<TransactionTypeTagProps> = ({ value, variant = 'soft', className }) => {
  const meta = transactionTypeMeta(value);

  if (!meta.label) return null;

  const classNames = ['transaction-type-tag', variant === 'plain' ? 'transaction-type-tag--plain' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classNames} color={variant === 'solid' ? meta.solidColor : meta.color}>
      {meta.icon}
      <span>{meta.label}</span>
    </Tag>
  );
};

export default TransactionTypeTag;
